export default {
  index: [
    {
      path: '/qykjtype',
      component: resolve => require(['./qykjtypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qykjtype/_router.js